import React, { memo, useEffect } from "react";
import { HomeWrapperd } from "./style";
import axios from "axios";
import Logo from "../static/logo.svg";
import { useLocation } from "react-router-dom";
function useQueryParams() {
  // 使用 useLocation 钩子获取 location 对象
  const location = useLocation();
  // 创建 URLSearchParams 对象来解析查询参数
  const searchParams = new URLSearchParams(location.search);
  // 创建一个空对象来存放查询参数
  let params = {};
  // 使用 forEach 方法获取所有的查询参数
  for (let [key, value] of searchParams.entries()) {
    params[key] = value;
  }
  // 返回查询参数对象
  return params;
}
export default memo(function Home() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://s1.hdslb.com/bfs/cm/cm-sdk/static/js/track-collect.js";
    script.async = true;
    document.body.appendChild(script);
    getwxUrl();
  }, []);
  const data = useQueryParams();
  const getwxUrl = async () => {
    axios
      .get("https://api.fzscw.com/small-app/monitor/link/wechat/getScheme", {
        params: data,
      })
      .then((res) => {
        window.bilicm.mbase.report_data();
        setTimeout(() => {
          window.location.href = res.data.openlink;
        }, 100);
      });
  };
  return (
    <HomeWrapperd>
      <div className="container">
        <div className="header">
          <div className="logo">
            <img src={Logo} alt="logo" />
          </div>
          <div className="title">沣竹书院</div>
        </div>
        <div className="button" onClick={getwxUrl}>
          打开小程序
        </div>
      </div>
    </HomeWrapperd>
  );
});
